import type { ProjectPathParams, ProjectTeamInviteBody } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

type SendProjectInviteParams = ProjectPathParams & ProjectTeamInviteBody;

export function useSendProjectInvite() {
  const queryClient = useQueryClient();
  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, ...body }: SendProjectInviteParams) =>
      post({
        url: `/projects/${projectId}/team/invite`,
        body,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectTeamInvites(projectId),
      });
    },
  });

  const sendProjectInvite = useCallback(
    (params: SendProjectInviteParams) => mutate(params),
    [mutate]
  );

  return {
    sendProjectInvite,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
